<template>
  <div class="header-container">
    <div class="header-main lw-flex is-justify-space-between is-align-middle">
      <img :src="logo" class="logo" alt="" @click="handleToView('online')">
      <div class="expand-box" @click="hadnleToggleMenu">
        <div class="expand-box__item"></div>
        <div class="expand-box__item"></div>
        <div class="expand-box__item"></div>
      </div>
    </div>
    <transition name="expand">
      <div class="menu-main" v-show="isExpand">
        <div class="menu-item lw-flex is-justify-space-between is-align-middle" @click="handleToView('inform')">
          <div class="arrow"></div>
          <div class="menu-name">3D打印功能性定制鞋垫</div>
        </div>
        <div class="menu-item lw-flex is-justify-space-between is-align-middle" @click="handleToView('online')">
          <div class="arrow"></div>
          <div class="menu-name">在线打印</div>
        </div>
        <!-- <div class="menu-item lw-flex is-justify-space-between is-align-middle" @click="handleToWeb">
          <div class="arrow"></div>
          <div class="menu-name">创业同行</div>
        </div> -->
        <div class="menu-item lw-flex is-justify-space-between is-align-middle" @click="handleToView('newsList')">
          <div class="arrow"></div>
          <div class="menu-name">资讯中心</div>
        </div>
        <div class="menu-item lw-flex is-justify-space-between is-align-middle" @click="handleToView('aboutUs')">
          <div class="arrow"></div>
          <div class="menu-name">关于我们</div>
        </div>
      </div>
    </transition>
    <online-printer></online-printer>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import OnlinePrinter from '@/components/onlinePrinter'
export default {
  components: {
    OnlinePrinter
  },
  data () {
    return {
      isExpand: false,
      currentEle: ''
    }
  },
  mounted () {
    document.addEventListener('touchstart', (e) => {
      if(e.target.className !== 'expand-box__item' && !e.target.className.includes('expand-box')) {
        this.isExpand = false
      }
    })
  },
  methods: {
    hadnleToggleMenu () {
      this.isExpand = !this.isExpand
    },
    ...mapMutations({
      updateKey: 'updateKey'
    }),
    handleToView (view) {
      this.isExpand = false
      this.$router.push({path: `/${view}`})
    },
    handleToWeb () {
      window.location.href = 'http://3dprint.gdlwzn.com/Fall/Fall/index.html'
    }
  },
  computed: {
    ...mapState({
      configData: 'configData'
    }),
    logo () {
      if (this.configData && this.configData.top) {
        return this.configData.top.image.configValue
      }
    }
  }
}
</script>
